import { Box } from '@mui/material';
import StarIcon from '../../../assets/images/icons/star_blue.png';
import HistoryImage from '../../../assets/images/pages/history/history-image.png';
import { useUserStore } from '../../../stores/userStore';
import { addCommaToNumber } from '../../../utils/utils';

const HistoryCard = () => {
  const companyInfo = useUserStore((state) => state.companyInfo);
  const accumulatePoints = companyInfo?.accumulated_points
    ? addCommaToNumber(companyInfo?.accumulated_points)
    : '0';

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        height: '270px',
      }}
    >
      <Box
        component={'img'}
        src={HistoryImage}
        alt="History Image"
        sx={{
          position: 'absolute',
          bottom: '0',
          left: '45%',
          transform: 'translateX(-50%)',
          width: '100%',
          maxWidth: '300px',
        }}
      />

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 16px',
        }}
      >
        <Box sx={{ fontSize: '2.2rem', lineHeight: '2rem', fontWeight: '500', color: '#005972' }}>
          History
        </Box>
        <Box>
          <Box
            sx={{
              fontSize: '1.5rem',
              lineHeight: '1.5rem',
              fontWeight: '500',
              color: '#005972',
              textAlign: 'right',
            }}
          >
            คะแนนสะสม
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              fontSize: '2rem',
              lineHeight: '2rem',
              fontWeight: '500',
              color: '#005972',
            }}
          >
            <Box component="img" src={StarIcon} alt="Star" sx={{ height: '22px' }} />
            {accumulatePoints}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HistoryCard;
